// extracted by mini-css-extract-plugin
module.exports = {"faqItems":"FAQ_faqItems__jJN2M","faqItem":"FAQ_faqItem__rJJO8","faqChecksWrapper":"FAQ_faqChecksWrapper__m4oFd","underline":"FAQ_underline__T3xPp"};